import { Helmet } from "react-helmet";
import Header from '../header/Header';
import HeroCanales from './canales/HeroCanales';
import SectionCanales from './canales/SectionCanales';
import SectionDisfrutaCanales from './canales/SectionDisfrutaCanales';
import Accordion from '../elements/accordion/Accordion';
import { accordionDataCanales } from '../elements/accordion/AccordionDataCanales';
import Footer from '../footer/Footer';

function Canales() {


  return (
    <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Canales - XDigital Neo</title>
        </Helmet>
        <Header />
        <HeroCanales />
        <SectionCanales />
        <SectionDisfrutaCanales />
        <Accordion accordionData={accordionDataCanales} />
        <Footer />
    </>
  )
}

export default Canales